import React from "react";
import PropTypes from 'prop-types';

import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import Tooltip from "@material-ui/core/Tooltip";
import AppsIcon from "@material-ui/icons/Apps";
import ListIcon from "@material-ui/icons/List";

const ResourceToolbar = (props) => {
  
  const { layout, onSelectLayout } = props;

  const handleSelectLayout = (event, newLayout) => {
    if(onSelectLayout) {
      onSelectLayout(event, newLayout);
    }
  };

  return (
    <React.Fragment>
      <ToggleButtonGroup
        value={layout}
        exclusive
        onChange={handleSelectLayout}
        aria-label="resource layout"
        size="small"
        style={{ paddingLeft: '16px' }}
      >
        <ToggleButton value="list" aria-label="resource list" fontSize="small">
          <Tooltip title="Show list"><ListIcon/></Tooltip>
        </ToggleButton>
        <ToggleButton value="card" aria-label="resource cards" fontSize="small">
          <Tooltip title="Show cards"><AppsIcon/></Tooltip>
        </ToggleButton>
      </ToggleButtonGroup>
    </React.Fragment>
  );

};

ResourceToolbar.propTypes = {
  layout: PropTypes.oneOf(['list','card']).isRequired,
  onSelectLayout: PropTypes.func,
};

ResourceToolbar.defaultProps = {
  layout: 'list',
};

export default ResourceToolbar;
